import React, { useContext, useEffect, useState } from 'react';
import icons from '../../../../icons';
import style from './Category.module.css';

import { motion, AnimatePresence } from 'framer-motion';
import FlashCard from './FlashCard/FlashCard';
import { AppContext } from '../../../../AppContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../../firebase';

import Lottie from 'lottie-react';
import no_flashcards_animation from '../../../../lottieAnimations/schedule_animation.json';
import checkmark_animation from '../../../../lottieAnimations/checkmark.json';
import swipe_animation from '../../../../lottieAnimations/swipe_animation.json';

import IconButton from '../../../Buttons/IconButton/IconButton';


const compareDates = (firstDate, secondDate, strict=false) => {
    if (!firstDate || !secondDate) 
        return false;

    if (strict)
        return firstDate.getTime() === secondDate.getTime();
    
    return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
};

const getCurrentProgress = cards => Math.round(Object.values(cards).filter(card => compareDates(new Date(card.lastDone), new Date())).length / Object.values(cards).filter(card => isCardForToday(card) || compareDates(new Date(card.lastDone), new Date())).length * 100);
const isCardForToday = ({ lastDone, box }) =>
    (box === 1 && new Date().getTime() - new Date(lastDone).getTime() >= 1000 * 60 * 60 * 24) || 
    (box === 2 && new Date().getTime() - new Date(lastDone).getTime() >= 1000 * 60 * 60 * 24 * 2) || 
    (box === 3 && new Date().getTime() - new Date(lastDone).getTime() >= 1000 * 60 * 60 * 24 * 3);

const Category = props => {
    const { updateFlashCards, hideNavBar, showNavBar } = useContext(AppContext);

    const [showFlashcardsTutorial, setShowFlashcardsTutorial] = useState(localStorage.getItem("showFlashcardsTutorial") !== "false", Object.keys(props.category?.flashCards ?? {}).length > 0);
    const [currentProgress, setCurrentProgress] = useState(getCurrentProgress(props.category?.flashCards) !== Infinity ? getCurrentProgress(props.category?.flashCards) : 0);

    const [cards, setCards] = useState(props.category.flashCards);
    const [showAllCards, setShowAllCards] = useState(false);

    const setFlashCardDone = async (id, done=true) => {
        let newBox;
        switch(cards[id].box) {
            case 1:
                newBox = done ? 2 : 1;
                break;
            case 2:
                newBox = done ? 3 : 1;
                break;
            case 3:
                newBox = done ? 3 : 2;
                break;
        }

        const newFlashCard = { ...cards[id], lastDone: (new Date()).toString(), box: newBox };
        setCards(oldCards => ({ ...oldCards, [id]: newFlashCard }));
        updateFlashCards({ [props.category.id]: { ...props.category, flashCards: { ...cards, [id]: newFlashCard } } })
        await updateDoc(doc(db, `flashcards/${props.category.id}`), { [`flashCards.${id}`]: newFlashCard });
    }

    useEffect(() => {
        if (!props.active) {
            Object.values({ ...cards }).forEach(card => {
                const newCard = card;
                delete card.done;
                setCards(oldCards => ({ ...oldCards, [card.id]: newCard }));
            });
            setShowAllCards(false);
        }
    }, [props.active]);

    useEffect(() => {
        if (showFlashcardsTutorial) hideNavBar();
        else showNavBar();
    }, [showFlashcardsTutorial]);

    useEffect(() => {
        setCurrentProgress(getCurrentProgress(cards));
    }, [cards]);

    return <motion.main
        className={ style.main }
        transition={{ duration: .5 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        style={{ 
            "--currentBarProgress": `${isNaN(currentProgress) ? 0 : currentProgress}%`, 
            "--currentBarBorders": currentProgress === 100 ? "2rem" : "2rem 0 0 2rem",
            transform: props.last ?  "translate(-13.5vw, 0)" : null,
        }}>
            { showFlashcardsTutorial && <motion.div initial={{ y: "100vh" }} animate={{ y: 0 }} className={ style.tutorialPopup } onClick={ () => {
                localStorage.setItem("showFlashcardsTutorial", false);
                setShowFlashcardsTutorial(false);
            } }>
                <div className={ style.tutorialContent }>
                    <h3 style={{ color: "var(--orange)", textAlign: "center", fontSize: "1.3rem" }}>FLASHCARDS</h3>
                    <h4 style={{ textAlign: "center" }}>Clicca sul tasto "Risposta" per svelare la risposta</h4>
                    <h4 style={{ textAlign: "center" }}>Poi fai swipe verso destra se rispondi alla domanda correttamente, altrimenti fai swipe verso sinistra</h4>
                    <div className={ style.fakeCard }>
                    </div>
                    <motion.div className={ style.fakeCard } initial={{ rotateX: 0, left: 15, bottom: 15, background: "linear-gradient(to right bottom, #45a24786, #283c8680)" }} animate={{ rotate: 15, left: 40, bottom: 50, background: "linear-gradient(to right bottom, #45a247, #283c86)"  }} transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse", delay: 1.5 }} style={{ position: "absolute", width: "calc(100vw - 4rem)"  }}>
                        <motion.img initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ repeat: Infinity, repeatType: "reverse", duration: 1.5, delay: 1.5 }} src={ icons.check_icon } style={{ margin: "auto", width: "5rem", height: "5rem" }}></motion.img>
                    </motion.div>
                    <motion.div className={ style.fakeCard } initial={{ rotateX: 0, left: 15, bottom: 15, background: "linear-gradient(to right bottom, #45a24786, #283c8680)" }} animate={{ rotate: -15, left: -25, bottom: 50, background: "linear-gradient(to right bottom, #833ab4, #fd1d1d)"  }} transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }} style={{ position: "absolute", width: "calc(100vw - 4rem)"  }}>
                        <motion.img initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ repeat: Infinity, repeatType: "reverse", duration: 1.5 }} src={ icons.cross_icon } style={{ margin: "auto", width: "3rem", height: "3rem" }}></motion.img>
                    </motion.div>
                </div>
            </motion.div> }
            <div className={ style.category }>
                <div className={ style.flex } onClick={ props.close } style={{ marginLeft: "1rem", marginTop: "1rem" }}>
                    <img src={ icons.arrow_left_icon } style={{ width: "1.5rem" }}></img>
                    <h1 style={{ flex: 1, marginTop: "0", marginBottom: "0", fontSize: "1.3rem", marginLeft: "1rem", marginRight: "2rem", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>{ props.category.name }</h1>
                    <img src={ icons.edit_icon } style={{ marginRight: "2rem" }} onClick={ () => {
                        props.edit();
                    } }></img>
                </div>
                <div className={ style.currentProgressBar } style={{ marginTop: "2rem", paddingTop: ".25rem", paddingBottom: ".25rem" }} >
                    <h3 style={{ textAlign: "center", marginTop: "0", marginBottom: "0", position: "relative" }}>{ isNaN(currentProgress) ? "0" : currentProgress }%</h3>
                </div>
                <h4 style={{ textAlign: "center", fontSize: ".9rem" }}><span style={{ color: "var(--orange)" }}>{ Object.values(cards).filter(card => compareDates(new Date(card.lastDone), new Date())).length }/{ Object.values(cards).filter(card => isCardForToday(card) || compareDates(new Date(card.lastDone), new Date())).length }</span> completate oggi</h4>
                <div style={{ marginTop: "2rem" }}>
                    <AnimatePresence>
                        { Object.keys(cards).length === 0 ? 
                            <>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "2rem", marginBottom: "2rem" }}
                                    loop={ true }
                                    autoplay={ true }
                                    speed={ 0.1 }
                                    animationData={ no_flashcards_animation }
                                    height={ 200 }
                                    width={ 200 }
                                />
                                <IconButton icon={ icons.add_icon } text="Nuova flash card" iconStyle={{ width: "1rem", height: "1rem" }} style={{ paddingTop: ".5rem", paddingBottom: ".5rem" }} onClick={ () => {
                                    props.close();
                                    props.showAdd();
                                } } />
                            </> : 
                            (showAllCards && Object.values(cards).filter(card => !card.done).length > 0) ? Object.entries(cards).filter(([, card]) => !card.done).slice(0, 3).sort(([first, second]) => first.box - second.box).map(([index, card]) => <FlashCard key={ `flashCard-${index}` } showAdd={ props.showAdd } setAddProps={ props.setAddProps } idx={ Object.values(cards).filter(card => !card.done).indexOf(card) } index={ index } card={ card } setDone={ id => setCards(oldCards => ({ ...oldCards, [id]: { ...oldCards[id], done: true } })) } categoryId={ props.category.id } showFlashcardsTutorial={ () => setShowFlashcardsTutorial(true) } />) :
                            Object.values(cards).filter(isCardForToday).length > 0 ? 
                                Object.entries(cards).filter(([, card]) => isCardForToday(card)).slice(0, 3).sort(([first, second]) => first.box - second.box).map(([index, card]) => <FlashCard key={ `flashCard-${index}` } showAdd={ props.showAdd } setAddProps={ props.setAddProps } idx={ Object.values(cards).filter(isCardForToday).indexOf(card) } index={ index } card={ card } setDone={ setFlashCardDone } categoryId={ props.category.id } showFlashcardsTutorial={ () => setShowFlashcardsTutorial(true) } />) :
                                <motion.div initial={{ y: "100vh", opacity: 0 }} animate={{ y: (showAllCards && Object.values(cards).filter(card => !card.done).length > 0) ? "100vh" : 0, opacity: 1 }}>
                                    <Lottie 
                                        style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                        loop={ false }
                                        autoplay={ true }
                                        speed={ 0.1 }
                                        animationData={ checkmark_animation }
                                        height={ 200 }
                                        width={ 200 }
                                    />
                                    <IconButton icon={ icons.visibility_white_icon } text="Mostra tutte" style={{ paddingTop: ".5rem", paddingBottom: ".5rem" }} onClick={ () => {
                                        setShowAllCards(true);
                                        Object.values({ ...cards }).forEach(card => {
                                            const newCard = card;
                                            delete card.done;
                                            setCards(oldCards => ({ ...oldCards, [card.id]: newCard }));
                                        });
                                    } } />
                                </motion.div>
                        }
                    </AnimatePresence>
                </div>
            </div>
        </motion.main>
}

export default Category;